var _rect, _rect2, _rect3, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComplainceBoard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 76,
    viewBox: "0 0 75 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.532426,
    y: 0.550004,
    width: 73.9356,
    height: 73.9356,
    rx: 36.9678,
    fill: "#020407",
    fillOpacity: 0.04
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.532426,
    y: 0.550004,
    width: 73.9356,
    height: 73.9356,
    rx: 36.9678,
    stroke: "url(#paint0_linear_706_70397)",
    strokeWidth: 1.07657
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.532426,
    y: 0.550004,
    width: 73.9356,
    height: 73.9356,
    rx: 36.9678,
    stroke: "url(#paint1_linear_706_70397)",
    strokeWidth: 1.07657
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_706_70397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.2375 26.9984V25.8828C43.2375 24.7672 42.4406 23.8641 41.4844 23.8641H40.2094C40.1031 23.8641 39.9438 23.8109 39.8906 23.7047C39.7844 23.5984 39.7844 23.4922 39.7844 23.3859V23.1203C39.7844 21.7391 38.775 20.5703 37.5531 20.5703C36.3312 20.6766 35.375 21.7922 35.375 23.1734V23.4391C35.375 23.5453 35.375 23.6516 35.2687 23.7578C35.1625 23.8641 35.0563 23.9172 34.95 23.9172H33.675C33.0375 23.9172 32.4 24.3422 32.1344 25.0328C32.0281 25.2984 31.9219 25.6172 31.9219 25.9359V27.0516H43.1312L43.2375 26.9984Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3379 25.0336C48.0191 24.8211 47.6473 24.7148 47.2754 24.7148H44.0348V24.8211C44.0879 24.9805 44.0879 25.7242 44.0879 25.8836V26.468H45.8941C46.7441 26.468 47.4348 27.1586 47.4348 28.0086V51.0648C47.4348 51.9148 46.7441 52.6055 45.8941 52.6055H29.266C28.416 52.6055 27.7254 51.9148 27.7254 51.0648V28.0086C27.7254 27.1586 28.416 26.468 29.266 26.468H31.0723V25.4055C31.0723 25.2461 31.0723 25.0336 31.1254 24.8742V24.768H27.7254C26.6098 24.768 25.7598 25.7773 25.7598 26.9992V52.1273C25.7598 53.3492 26.6629 54.3586 27.7254 54.3586H47.4348C47.8598 54.3586 48.2316 54.1992 48.6035 53.9336C49.0285 53.5617 49.2941 52.9773 49.2941 52.3398V26.7867C49.241 26.043 48.9223 25.3523 48.3379 25.0336Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0721 27.3174H29.2658C28.8939 27.3174 28.5752 27.6361 28.5752 28.008V51.0643C28.5752 51.4361 28.8939 51.7549 29.2658 51.7549H45.8939C46.2658 51.7549 46.5846 51.4361 46.5846 51.0643V28.008C46.5846 27.6361 46.2658 27.3174 45.8939 27.3174H44.0877V27.4236C44.0877 27.6361 43.8752 27.8486 43.6627 27.8486H31.4971C31.2846 27.8486 31.0721 27.6361 31.0721 27.4236V27.3174ZM31.8158 31.3018H43.2908C43.5033 31.3018 43.7158 31.5143 43.7158 31.7268C43.7158 31.9393 43.5033 32.1518 43.2908 32.1518H31.8158C31.6033 32.1518 31.3908 31.9393 31.3908 31.7268C31.3908 31.5143 31.6033 31.3018 31.8158 31.3018ZM31.8158 36.508H43.2908C43.5033 36.508 43.7158 36.7205 43.7158 36.933C43.7158 37.1455 43.5033 37.358 43.2908 37.358H31.8158C31.6033 37.358 31.3908 37.1455 31.3908 36.933C31.3908 36.6674 31.6033 36.508 31.8158 36.508ZM31.8158 41.6611H43.2908C43.5033 41.6611 43.7158 41.8736 43.7158 42.0861C43.7158 42.2986 43.5033 42.5111 43.2908 42.5111H31.8158C31.6033 42.5111 31.3908 42.2986 31.3908 42.0861C31.3908 41.8736 31.6033 41.6611 31.8158 41.6611ZM31.8158 46.8674H43.2908C43.5033 46.8674 43.7158 47.0799 43.7158 47.2924C43.7158 47.5049 43.5033 47.7174 43.2908 47.7174H31.8158C31.6033 47.7174 31.3908 47.5049 31.3908 47.2924C31.3908 47.0268 31.6033 46.8674 31.8158 46.8674Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_706_70397",
    x1: -8.17251,
    y1: 4.24628,
    x2: 74.7039,
    y2: 75.0239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024751",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.323723,
    stopColor: "#024751",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_706_70397",
    x1: 89.8273,
    y1: 91.9622,
    x2: 2.71635,
    y2: 30.2586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024751"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544,
    stopColor: "#024751",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_706_70397"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(20.5 20.5176)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplainceBoard);
export default __webpack_public_path__ + "static/media/ComplainceBoard.bafa3f5052f8899a6f91f562c1f51003.svg";
export { ForwardRef as ReactComponent };